import { BusinessImpactEnum, OverdueImpactEnum, PriorityEnum } from 'app/enum';
import { ModelWithoutId } from 'app/type';

import { Brand } from './cris/brand';
import { Store } from './cris/store';
import { RestfulModel } from './restful-model';
import { User } from './user';
import { SeamStatus } from '../constants/seam-status';

export interface CrisRequest extends RestfulModel {
    jiraLink: string;
    brand?: Brand;
    store?: Store;
    customer?: string;
    project?: string;
    description: string;
    priority: PriorityEnum;
    taggerPriority?: PriorityEnum;
    businessImpact?: BusinessImpactEnum;
    overdueImpact?: OverdueImpactEnum;
    currentPlace: SeamStatus;
    dueDate: string;
    dateCreated: string;
    estimatedDelivery?: string;
    owner?: User;
    userCreated?: User;
    // for temporary storage of brand data prior to creation of new brand
    brandData?: ModelWithoutId<Brand>;
    // for temporary storage of store data prior to creation of new store
    storeData: Array<ModelWithoutId<Store>>;
    // for temporary storage during creation
    elementName?: string;
}

/**
 * Makes a blank object of CrisRequestRouter type
 */
export const makeCrisRequest = (): ModelWithoutId<CrisRequest> => ({
    jiraLink: '',
    description: '',
    currentPlace: SeamStatus.TXN_CHECK as SeamStatus,
    dueDate: '',
    dateCreated: '',
    storeData: [],
    priority: PriorityEnum.P4,
});
